import script from "./personalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./personalCenter.vue?vue&type=script&setup=true&lang=js"

import "./personalCenter.vue?vue&type=style&index=0&id=24f62f5a&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f62f5a"]])

export default __exports__